module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/38BOX3/image/FC-9781035828647.jpg?1708992404899",
      "alt": "This image is the cover for the book Declan at the Beach"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Declan at the Beach\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Meet Declan, a fun-loving and friendly dolphin as he goes to the beach. Who will he find? Join him on his aquatic journey where he meets many new friends. Using original art and rhyme, this colorful, lively and engaging adventure teaches numbers and the number words. This book will captivate children, adults and beach lovers all over the world and is sure to be a favorite in their library for years to come.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lisa Ferrucci, Lisa Ferrucci\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Born and raised in Rhode Island, Lisa has been an elementary teacher and artist for over 25 years. She shares her art with artisan groups and local galleries. Inspired by her new grandson, Lisa wrote this book combining her love of teaching young readers and her passion for the ocean. You will often see her on the beach painting, collecting treasures or writing notes for her next children’s book.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0